import { sdk } from '@/lib/api';
import { FetchError } from '@/lib/api/client';
import { queryKeysFactory } from '@/lib/query-key-factory';
import { HttpTypes } from '@/types';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

const COLLECTIONS_QUERY_KEY = 'collections' as const;
const COLLECTION_DETAIL_QUERY_KEY = 'collection-detail' as const;

export const collectionsQueryKeys = queryKeysFactory(COLLECTIONS_QUERY_KEY);
export const collectionDetailQueryKeys = queryKeysFactory(COLLECTION_DETAIL_QUERY_KEY);

export const useCollections = (
  query: HttpTypes.FindParams,
  options?: Omit<
    UseQueryOptions<
      HttpTypes.StoreCollectionsListResponse,
      FetchError,
      HttpTypes.StoreCollectionsListResponse,
      QueryKey
    >,
    'queryFn' | 'queryKey'
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: collectionsQueryKeys.list(query),
    queryFn: async () => sdk.site.collections.list(query),
    ...options,
  });

  return { data, ...rest };
};

export const useCollectionDetail = (
  slug: string,
  options?: Omit<
    UseQueryOptions<
      HttpTypes.IResponse<HttpTypes.StoreCollection>,
      FetchError,
      HttpTypes.IResponse<HttpTypes.StoreCollection>,
      QueryKey
    >,
    'queryFn' | 'queryKey'
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: collectionDetailQueryKeys.detail(slug),
    queryFn: async () => sdk.site.collections.detail(slug),
    ...options,
  });

  return { data, ...rest };
};
